import { Badge } from '@nexelem/components';

import { selectTaskCountByStatus, useKanbanEventStore } from '../store';
import { useCustomTranslation } from '../../../../../hooks';
import { TaskStatus } from '@nexelem/graphne-api';
import clsx from 'clsx';
import { isAllowedMoveQueue } from '../utils';
import { useDndContext } from '@dnd-kit/core';
import { SupportedKanbanStatus } from '../SupportedKanbanStatuses';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-light-svg-icons';

export const KanbanColumnHeader = ({ status, className }: KanbanColumnHeaderProps) => {
  const { active } = useDndContext();
  const { tWrapper } = useCustomTranslation('products.productionPlan.kanban');

  const columns: Record<SupportedKanbanStatus, string> = {
    [TaskStatus.Pending]: tWrapper('planned'),
    [TaskStatus.InProgress]: tWrapper('inProduction'),
    [TaskStatus.Completed]: tWrapper('inWarehouse'),
  };

  const taskCounter = useKanbanEventStore(selectTaskCountByStatus(status));

  const fromStatus = active?.data.current?.taskStatus;
  const isQueueActive = !fromStatus || isAllowedMoveQueue({ toStatus: status, fromStatus });

  return (
    <div className={clsx('flex items-center justify-center gap-2 py-3', className)}>
      {!isQueueActive && <FontAwesomeIcon icon={faLock} />}
      <span className={clsx('text-t16-sb', isQueueActive ? getStatusColor(status) : 'text-text-secondary')}>
        {columns[status]}
      </span>
      <Badge>{taskCounter || '0'}</Badge>
    </div>
  );
};

const variants: Partial<Record<TaskStatus, string>> = {
  [TaskStatus.Pending]: 'text-text-status-yellow',
  [TaskStatus.InProgress]: 'text-text-status-navy',
  [TaskStatus.Completed]: 'text-text-status-green',
};

export const getStatusColor = (status: TaskStatus) => variants[status] || 'text-text-secondary';
type KanbanColumnHeaderProps = {
  status: SupportedKanbanStatus;
  className?: string;
};
